module.exports = __webpack_public_path__ + "img/jnmh_02.6a61052a.jpg";